
import axios from "axios";
import {
    ApiManager,
    ApiEndpoints,
    batchDataService,
    UtilityLibrary,
    LoggerUtility
} from '../components/ComponentsLibrary';


const GetFileUncPath = async (apiUrl, uncFileName) => {
    try {
        /* const apiHeaders = ApiManager.GetApiHeaders();
        const config = { 
            headers: { ...apiHeaders },
            responseType: 'arraybuffer'
        };
        const response = await axios.post(
            apiUrl,
            { path: uncFileName },
            config
        ); */

        const response =  await ApiManager.GetUncFilePathFromApi(uncFileName);
        // const response = await axios.post(apiUrl, { path: uncFileName }, {
        //     responseType: 'arraybuffer'
        // });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const objectUrl = window.URL.createObjectURL(blob);
        const url = new URL(objectUrl);
        //return url.href;
        return { hasError: false, isFileExists: true, fileUrl: url.href, errorList: "" }
    }
    catch (error) {
        //throw await LoggerUtility.ProcessErrorData(error, "GetFileUncPath", {});
        return { hasError: true, isFileExists: false, fileUrl: "", errorList: await LoggerUtility.ProcessErrorData(error, "GetFileUncPath", {}) }
    }
} 


  const SaveFileToPhysicalPath = async (blob, uncfullpath) => {
    try {
        // const docData = {
        //     "file": blob,
        //     "uncfullpath": uncfullpath,
        // }

        // const response = await ApiManager.SaveFileToPhysicalPath(docData);
      //const arrayBuffer = await instance.exportPDF();
      //const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
        const formData = new FormData();
        formData.append("file", blob);
        formData.append("uncfullpath", uncfullpath);

    //   const docUploadApiUrl = await ApiEndpoints.DocumentUploadApiUrl();
    //   const response = await fetch((docUploadApiUrl.ApiUrl), {
    //     method: "POST",
    //     body: formData
    //   });

        const response = await ApiManager.SaveFileToPhysicalPath(formData);
        return response;

    //   if (response.ok) {
    //     const result = await response.json();
    //     console.log(result.Message);
    //   } else {
    //     console.error('Save failed:', response.statusText);
    //   }
    } catch (error) {
        throw error
    }
  };

  


const GetFileUncPath21 = async (apiUrl, uncFileName) => {
    try {
        const apiHeaders = ApiManager.GetApiHeaders();
        const config = { 
            headers: { ...apiHeaders },
            responseType: 'arraybuffer'
        };
        const response = await axios.post(
            apiUrl,
            { path: uncFileName },
            config
        );

        // const response = await axios.post(apiUrl, { path: uncFileName }, {
        //     responseType: 'arraybuffer'
        // });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const objectUrl = window.URL.createObjectURL(blob);
        const url = new URL(objectUrl);
        //return url.href;
        return { hasError: false, isFileExists: true, fileUrl: url.href, errorList: "" }
    }
    catch (error) {
        //throw await LoggerUtility.ProcessErrorData(error, "GetFileUncPath", {});
        return { hasError: true, isFileExists: false, fileUrl: "", errorList: await LoggerUtility.ProcessErrorData(error, "GetFileUncPath", {}) }
    }
} 


const GetFileUncPath02 = async (apiUrl, uncFileName) => {
    try {

        const fileExistsApiUrl = ApiManager.DocumentExistsApiUrl;
        const config = {
            params: { path: uncFileName },
            headers: {
                'Content-Type': 'application/json', // Ensure this matches API expectations
                Accept: 'application/json',
            },
            validateStatus: function (status) {
                // Resolve the promise for status codes 200
                return status >= 200 && status <= 500;
              }
        };
        const isFileExists = await axios.get(fileExistsApiUrl, config);
        if (isFileExists.status === 200 && isFileExists.data) {

            const response = await axios.post(apiUrl, { path: uncFileName }, {
                responseType: 'arraybuffer'
            });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const objectUrl = window.URL.createObjectURL(blob);
            const url = new URL(objectUrl);
            return { isFileExists: true, fileUrl: url.href }
        }
        else {
            return { isFileExists: false, fileUrl: "" }
        }
    }
    catch (error) {
        console.error('Error fetching document:', error);
        return { isFileExists: false, fileUrl: "" }
    }
}


const GetFileUncPath03 = async (apiUrl, uncFileName) => {
    try {
        const apiHeaders = ApiManager.GetApiHeaders();
        const config = { 
            headers: { ...apiHeaders },
            responseType: 'arraybuffer'
        };
        const response = await axios.post(
            apiUrl,
            { path: uncFileName },
            config
        );

        // const response = await axios.post(apiUrl, { path: uncFileName }, {
        //     responseType: 'arraybuffer'
        // });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const objectUrl = window.URL.createObjectURL(blob);
        const url = new URL(objectUrl);
        return url.href;
    }
    catch (error) {
        throw await LoggerUtility.ProcessErrorData(error, "GetFileUncPath", {});
    }
} 


const DocumentUtility = {
    GetFileUncPath,
    SaveFileToPhysicalPath
};


export default DocumentUtility;
